<div class="forget-page">
  <mat-card class="forget-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Forget Password</mat-card-title>
      <mat-card-subtitle>Enter your email to receive a reset link</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()" class="forget-form">
        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" autocomplete="email" />
          </mat-form-field>

          @if(forgetPasswordForm.get('email')?.invalid && (forgetPasswordForm.get('email')?.dirty || forgetPasswordForm.get('email')?.touched)) {
          @if(forgetPasswordForm.get('email')?.errors?.['required']) {
          <div class="error">Email is required.</div>
          }
          @if(forgetPasswordForm.get('email')?.errors?.['email']) {
          <div class="error">Enter a valid email address.</div>
          }
          }
        </div>

        <button mat-flat-button type="submit" color="primary" class="submit-btn" [disabled]="isSubmitting()">
          @if (isSubmitting()) { Sending... } @else { Send Reset Link }
        </button>
      </form>

      @if (errorMessage()) {
      <div class="error-message">{{ errorMessage() }}</div>
      }
      @if (successMessage()) {
      <div class="success-message">{{ successMessage() }}</div>
      }

      <a class="back-link" routerLink="/login">Back to Login</a>
    </mat-card-content>
  </mat-card>
</div>
